import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { Input } from '@beef/ui-kit';
// constants
import classNames from 'classnames/bind';
import { POPUP_CONNECTION_STATE, flatMask } from "../../../../../../../../store/common/constants";
import { AddressInput } from "./AddressInput";
// components
import { AddressSectionTitle } from "./AddressSectionTitle";
import { InputWrapper } from "./InputWrapper";
// styles
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var AddressForm = function AddressForm(_ref) {
  var fetchHouses = _ref.fetchHouses,
    fetchStreets = _ref.fetchStreets,
    flat = _ref.flat,
    house = _ref.house,
    onSelectHouseFromList = _ref.onSelectHouseFromList,
    onSelectStreetFromList = _ref.onSelectStreetFromList,
    region = _ref.region,
    setAddressChecked = _ref.setAddressChecked,
    setFocusFlat = _ref.setFocusFlat,
    setSelectedFlat = _ref.setSelectedFlat,
    setSelectedHouse = _ref.setSelectedHouse,
    setSelectedStreet = _ref.setSelectedStreet,
    street = _ref.street,
    texts = _ref.texts;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    houseValue = _useState2[0],
    setHouseValue = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    streetValue = _useState4[0],
    setStreetValue = _useState4[1];
  var onClearFlat = function onClearFlat() {
    setSelectedFlat('');
    setAddressChecked(POPUP_CONNECTION_STATE.isNone);
  };
  var handleChangeHouseInput = function handleChangeHouseInput(value) {
    setHouseValue(value);
    if (!value) {
      setSelectedHouse({});
      onClearFlat();
    }
  };
  var handleChangeStreetInput = function handleChangeStreetInput(value) {
    setStreetValue(value);
    if (!value) {
      setSelectedStreet({});
      handleChangeHouseInput(value);
    }
  };
  var onChangeFlat = function onChangeFlat(e) {
    setSelectedFlat(e.target.value);
  };
  var onFocusFlat = function onFocusFlat() {
    setFocusFlat('');
  };
  useEffect(function () {
    if (street) {
      setStreetValue(street.label);
    }
    if (house) {
      setHouseValue(house.label);
    }
  }, [street, house]);
  return /*#__PURE__*/React.createElement("div", {
    "data-t-id": "AddressRequestInputsSection-components"
  }, /*#__PURE__*/React.createElement(AddressSectionTitle, {
    city: texts.city,
    region: region
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('address')
  }, /*#__PURE__*/React.createElement(InputWrapper, {
    className: cx('address__street'),
    label: texts.street
  }, /*#__PURE__*/React.createElement(AddressInput, {
    onChange: handleChangeStreetInput,
    onSearch: fetchStreets,
    onSelect: onSelectStreetFromList,
    value: streetValue,
    "data-t-id": "AddressRequestInputsSection-components"
  })), /*#__PURE__*/React.createElement(InputWrapper, {
    className: cx('address__house'),
    label: texts.house
  }, /*#__PURE__*/React.createElement(AddressInput, {
    disabled: !street.isConnected,
    onChange: handleChangeHouseInput,
    onSearch: fetchHouses,
    onSelect: onSelectHouseFromList,
    value: houseValue,
    "data-t-id": "AddressRequestInputsSection-components"
  })), /*#__PURE__*/React.createElement(InputWrapper, {
    className: cx('address__flat'),
    label: texts.flat
  }, /*#__PURE__*/React.createElement(Input, {
    disabled: !house.isConnected,
    maskSettings: flatMask,
    onChange: onChangeFlat,
    onClear: onClearFlat,
    onFocus: onFocusFlat,
    value: flat,
    "data-t-id": "AddressRequestInputsSection-components"
  }))));
};